import { render, staticRenderFns } from "./SQBody.vue?vue&type=template&id=3e0a17bf&"
import script from "./SQBody.vue?vue&type=script&lang=ts&"
export * from "./SQBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports